import { render, staticRenderFns } from "./customPageShow.vue?vue&type=template&id=da22f172&scoped=true"
import script from "./customPageShow.vue?vue&type=script&lang=js"
export * from "./customPageShow.vue?vue&type=script&lang=js"
import style0 from "./customPageShow.vue?vue&type=style&index=0&id=da22f172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da22f172",
  null
  
)

export default component.exports